module.exports = __webpack_public_path__ + "img/按钮关闭浅色.d347b776.png";